import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Side from "./Side";
import authActions from "../../../store/actions/authActions";

function Logout({ isUserLoggedIn, userLogout }) {
  return (
    <div className="ltr container-fluid  " id="container-auth-page">
      <div className="row h-100">
        <Side />
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 h-lg-100 py-5 p-lg-0"
          id="container-auth-page-box"
        >
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div id="auth-page-box">
              <div className="border-radius-auth-page">
                <div className="header-box border-radius-auth-page py-1 px-3">
                  خروج از حساب کاربری
                </div>
                <div className="body-box d-flex flex-column pt-5 pb-4 px-3">
                  <div className="logout-box pt-4 border-hilite-2 border-radius-auth-page">
                    <div>
                      <span className="pr-2">
                        آیا مطمئن هستید که می خواهید از حساب کاربری خود خارج
                        شوید؟
                      </span>
                    </div>
                    <div className="d-flex justify-content-around py-3">
                      <span>
                        <button
                          className="btn btn-hilite-2 w-100 border-radius-auth-page"
                          onClick={() => {
                            userLogout();
                          }}
                        >
                          بله , خارج شو
                        </button>
                      </span>
                      <span>
                        <Link
                          to="/"
                          className="btn btn-hilite-1 w-100 border-radius-auth-page"
                        >
                          خیر , بازگشت به پنل
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between pt-1">
                <span>info@hilite.ir</span>
                <span>۰۲۱-۶۶۷۵۷۳۷۹</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isUserLoggedIn: state.main.isUserLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userLogout: () => {
      dispatch({
        type: authActions.USER_DO_LOGOUT,
        payload: null,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
